import React, { useContext } from "react";
import {
  ChartsAxisTooltipContent,
  ChartsTooltipContainer,
  ChartsTooltipContainerProps,
  useAxesTooltip,
} from "@mui/x-charts";

import { TooltipFooterContext } from "./tooltipFooterContext";

export const TooltipWithFooter: React.FC<ChartsTooltipContainerProps> = (
  props,
) => {
  const footer = useContext(TooltipFooterContext);
  const dataIndex = useAxesTooltip()?.[0]?.dataIndex;
  const footerContent =
    footer && dataIndex !== undefined ? footer(dataIndex) : null;

  return (
    <ChartsTooltipContainer {...props} trigger="axis">
      <ChartsAxisTooltipContent />
      {footerContent}
    </ChartsTooltipContainer>
  );
};
